<template>
  <div class="solution-root-video">
    <div class="content">
      <SectionTitle title="我们的解决方案" titleEN="Solutions" />
      <div class="indicator-wrapper">
        <div class="indicator">
          <div class="indicator-inner" :class="`indicator-inner-${index}`"></div>
        </div>
        <div class="toolbar">
          <div role="button" class="btn" :class="{ 'btn-active': index === 0 }">
            {{ $isCN() ? "数字化" : "Digitalize" }}
          </div>
          <div role="button" class="btn" :class="{ 'btn-active': index === 1 }">
            {{ $isCN() ? "智能化" : "Intelligent" }}
          </div>
          <div role="button" class="btn" :class="{ 'btn-active': index === 2 }">
            {{ $isCN() ? "网络化" : "Integration" }}
          </div>
        </div>
      </div>
    </div>
    <video :muted="true" :loop="true" class="video" ref="videoEl" preload="auto" :playsinline="true">
      <source v-for="item in videoSrc" :key="item[1]" :src="item[1]" :type="item[0]" />
    </video>
  </div>
</template>

<script>
import SectionTitle from "../../components/SectionTitle.vue";
export default {
  components: { SectionTitle },
  data() {
    return {
      index: 0,
    };
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobileSite;
    },
    videoSrc() {
      if (this.$isCN()) {
        if (this.isMobile) {
          return [
            // ["video/webm", "//res-fengche.souche.com/f2e/67070c475b88c464af97f47bcf1c0d3e.webm"],
            ["video/mp4", "//assets-dfc.souche.com/f2e/f5388c7c-9a07-476f-a484-a381d40a825f.mp4"],
          ];
        }
        return [
          // ["video/webm", "//res-fengche.souche.com/f2e/dfcea83e256b963a0558408c187cab0d.webm"],
          ["video/mp4", "//res-fengche.souche.com/f2e/e910ed1e865eb5376a5e561b8fc722e6.mp4"],
        ];
      } else {
        if (this.isMobile) {
          return [
            // ["video/webm", "//res-fengche.souche.com/f2e/5726308f4474d473495af87112a63c76.webm"],
            ["video/mp4", "//assets-dfc.souche.com/f2e/29e50f27-54fa-45bb-97d2-b571bca223de.mp4"],
          ];
        }
        return [
          // ["video/webm", "//res-fengche.souche.com/f2e/ff5cccd08de1490301a1c2a1faa3ad15.webm"],
          ["video/mp4", "//res-fengche.souche.com/f2e/6178037aadbff398a614f0e67a02d038.mp4"],
        ];
      }
    },
  },
  mounted() {
    this.listenVideoTimeUpdate = this.listenVideoTimeUpdate.bind(this);
    this.$refs.videoEl.addEventListener("timeupdate", this.listenVideoTimeUpdate);
    this.$refs.videoEl.onerror = (e) => {
      console.log(e);
      this.$emit("cannotplay");
    };
    this.obser = new IntersectionObserver(
      async (els) => {
        if (els[0].isIntersecting) {
          try {
            await this.$refs.videoEl.play();
          } catch (e) {
            console.log(e);
            this.$emit("cannotplay");
          }
        } else {
          this.$refs.videoEl.pause();
        }
      },
      { threshold: 0.5 }
    );
    this.obser.observe(this.$refs.videoEl);
  },
  beforeDestroy() {
    this.$refs.videoEl.removeEventListener("timeupdate", this.listenVideoTimeUpdate);
    this.obser.disconnect();
  },
  methods: {
    listenVideoTimeUpdate() {
      if (!this.$refs.videoEl) {
        return;
      }
      const currentTime = this.$refs.videoEl.currentTime;
      if (currentTime >= 11) {
        this.switchTo(2);
      } else if (currentTime >= 5) {
        this.switchTo(1);
      } else {
        this.switchTo(0);
      }
    },
    switchTo(index) {
      this.index = index;
    },
  },
};
</script>
<style scoped lang="less">
.solution-root-video {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  max-width: var(--min-content-width);
  margin: 0 auto;
}

.video {
  width: 100%;
  height: 100%;
  overflow: hidden;
  object-fit: contain;
}

.content {
  padding-top: 124px;
  box-sizing: border-box;
  display: flex;
  position: absolute;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  flex-direction: column;
  width: 100%;
  z-index: 2;
}

.indicator-wrapper {
  display: flex;
}
.indicator {
  margin-top: 145px;
  width: 2px;
  height: 203px;
  background-color: #cacacc;
  margin-right: 24px;
  margin-left: 24px;
  flex-shrink: 0;
  position: relative;

  &-inner {
    position: relative;
    height: 33%;
    width: 2px;
    top: 0;
    background-color: #ff571a;
    transition: top 0.2s;

    &-1 {
      top: 33%;
    }
    &-2 {
      top: 66%;
    }
  }
}
.toolbar {
  display: flex;
  overflow: hidden;
  flex-shrink: 0;
  flex-direction: column;
  margin-top: 120px;
  position: relative;

  .btn {
    height: 84px;
    font-weight: bold;
    font-size: 28px;
    line-height: 84px;
    color: #b4b5b7;

    &-active {
      color: #2b2c2e;
    }
  }
}

@media screen and (max-width: 540px) {
  .solution-root-video {
    flex-direction: column;
    width: 100%;
    height: auto;
  }

  .indicator {
    display: none;
  }

  .content {
    padding-top: 50px;
    box-sizing: border-box;
    flex-direction: column;
  }

  .video {
    height: auto;
  }
  .toolbar {
    margin-top: 10px;
    flex-direction: row;
    align-self: center;
    width: 100%;
    justify-content: space-around;

    .btn {
      height: 42px;
      font-size: 14px;
      line-height: 42px;
      cursor: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home-solutions-video/index.vue